export const demoConfig = {
    login: 'demo',
    password: '111111111',
};
